import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@Sage/hoi-poi-ui';

const Scorecard = memo(({ value, label, sublabel, valueColor }) => {
    return (
        <div className="fm-campaign-summary__scorecard">
            <Text type="h2" bold className="fm-campaign-summary__scorecard-value">
                {value}
            </Text>
            <Text
                type="body"
                className="fm-campaign-summary__scorecard-label"
                style={{ color: valueColor }}
            >
                {label}
            </Text>
            {sublabel && (
                <Text
                    type="body"
                    color="neutral700"
                    className="fm-campaign-summary__scorecard-sublabel"
                >
                    {sublabel}
                </Text>
            )}
        </div>
    );
});

Scorecard.displayName = 'Scorecard';

Scorecard.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    sublabel: PropTypes.string,
    valueColor: PropTypes.string,
};

export default Scorecard;
